import { Row } from 'antd'
import { PROVISIONED_UI_FLAGS } from '@Builder/QuoteDetailPage/logic'

import Box from '~/core/Box'
import {
    salesOrderLines_salesOrderLines_items_material as OrderMaterialDetails,
    salesOrderLines_salesOrderLines_items_processes as ProcessDetailsType,
} from '../Queries/__generated__/salesOrderLines'
import { useFlagEnabled } from '~/lib/isFlagEnabled'

import { ImOrderDetailsDisplayType } from './types'
import {
    getImOrderConfigDisplayValues,
    getToolLifeDisplayValue,
    getDisplayValue,
    getMaterialDisplayValue,
} from './logic'

export const ImOrderDetailsDisplay = (props: {
    processes?: ProcessDetailsType[]
    material?: OrderMaterialDetails | null
    isOrderStatusPage?: boolean
}) => {
    const { processes, material, isOrderStatusPage } = props
    const {
        primaryProcessDisplayName,
        materialDisplayName,
        materialGradeDisplayName,
        toolLifeDisplayName,
        colorCodeDisplayName,
        finishCodeDisplayName,
        finishDisplayName,
        colorDisplayName,
    }: ImOrderDetailsDisplayType = getImOrderConfigDisplayValues(
        processes,
        material,
    )

    const isImToolingEnabled = useFlagEnabled(
        PROVISIONED_UI_FLAGS.IM_TOOLING_UI,
    )

    const processDisplayName = () => {
        if (
            isOrderStatusPage &&
            primaryProcessDisplayName === 'Injection Molding Samples'
        ) {
            return 'Injection Molding - T samples'
        } else if (
            isOrderStatusPage &&
            primaryProcessDisplayName === 'Injection Molding'
        ) {
            return 'Injection Molding - Production parts'
        }
        return primaryProcessDisplayName
    }

    return (
        <>
            {!isImToolingEnabled && <Box>{processDisplayName()}</Box>}
            {!isImToolingEnabled && materialDisplayName && (
                <Box>
                    {getMaterialDisplayValue(
                        materialDisplayName,
                        materialGradeDisplayName,
                    )}
                </Box>
            )}
            {!isImToolingEnabled && toolLifeDisplayName && (
                <Box>{getToolLifeDisplayValue(toolLifeDisplayName)}</Box>
            )}
            {!isImToolingEnabled && colorDisplayName && (
                <Box>
                    Color (
                    {getDisplayValue({
                        attribute: colorDisplayName,
                        attributeCode: colorCodeDisplayName,
                    })}
                    )
                </Box>
            )}
            {!isImToolingEnabled && finishDisplayName && (
                <Box>
                    Finish (
                    {getDisplayValue({
                        attribute: finishDisplayName,
                        attributeCode: finishCodeDisplayName,
                    })}
                    )
                </Box>
            )}
            {isImToolingEnabled && (
                <>
                    <Row>
                        {materialDisplayName && (
                            <Box style={{ fontWeight: 300 }}>
                                {getMaterialDisplayValue(
                                    materialDisplayName,
                                    materialGradeDisplayName,
                                )}
                            </Box>
                        )}
                        {toolLifeDisplayName && (
                            <Box style={{ fontWeight: 300 }}>
                                {`, ${getToolLifeDisplayValue(
                                    toolLifeDisplayName,
                                )}`}
                            </Box>
                        )}
                    </Row>
                    {finishDisplayName && (
                        <Box style={{ fontWeight: 300, width: '100%' }}>
                            Finish (
                            {getDisplayValue({
                                attribute: finishDisplayName,
                                attributeCode: finishCodeDisplayName,
                            })}
                            )
                        </Box>
                    )}
                    {colorDisplayName && (
                        <Box style={{ fontWeight: 300, width: '100%' }}>
                            Color (
                            {getDisplayValue({
                                attribute: colorDisplayName,
                                attributeCode: colorCodeDisplayName,
                            })}
                            )
                        </Box>
                    )}
                </>
            )}
        </>
    )
}
